import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import PostTip from "@/pages/PostTip";
import Budget from "@/pages/Budget";
import Relaxation from "@/pages/Relaxation";
import Profile from "@/pages/Profile";
import Membership from "@/pages/Membership";
import Guidelines from "@/pages/Guidelines";
import Admin from "@/pages/Admin";
import Members from "@/pages/Members";
import PublicLanding from "@/pages/PublicLanding";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Layout from "@/components/Layout";
import { Loader2 } from "lucide-react";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F2]">
      <Loader2 className="w-8 h-8 animate-spin text-[#E8621A]" />
    </div>
  );
}

function ProtectedShell() {
  const { user, ready } = useAuth();
  if (!ready) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function GuestOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <LoadingScreen />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function RootHome() {
  const { user, ready } = useAuth();
  if (!ready) return <LoadingScreen />;
  if (user) return <Layout><Home /></Layout>;
  return <PublicLanding />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="/register" element={<GuestOnly><Register /></GuestOnly>} />
          <Route path="/guidelines" element={<Guidelines standalone />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/" element={<RootHome />} />
          <Route element={<ProtectedShell />}>
            <Route path="/post" element={<PostTip />} />
            <Route path="/budget" element={<Budget />} />
            <Route path="/relaxation" element={<Relaxation />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/members" element={<Members />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/community-guidelines" element={<Guidelines />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
